const AppState = {
  ATTRACT_SCREEN: 1,
  GETTING_READY_SCREEN: 2,
  READY_SCREEN: 3,
  ERROR_SCREEN: 4,
  SELECT_LANGUAGE_SCREEN: 5,
  ADMIN_SCREEN: 6,
  SCANNER_DETAILS_SCREEN: 7,
  PROFILE_NOT_FOUND_SCREEN: 8,
  ENTER_LOYALTY_CARD_SCREEN: 9,
  MESSAGE_SCREEN: 10,
  STAGING_SCREEN: 11,
  LOADING_SCREEN: 12,
  SELECT_SITE_AND_WALL_ID_SCREEN: 13,
  CONFIGURING_SCREEN: 14,
  ERROR_STAGING_SCREEN: 15,
  WELCOME_SCREEN: 16,
  CONFIGURATION_SUCCESS: 17,
  NO_DEVICES_AVAILABLE_SCREEN: 18,
  DEVICE_ALREADY_TAKEN_SCREEN: 19,
  WEB_SOCKET_CONNECTION_ERROR_SCREEN: 20,
};

export default AppState;
